"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_TYPE = exports.TEXT_ALIGN = exports.DISPLAY = exports.DEFAULT_TAG = exports.ARR_TEXT_TYPE = void 0;
const TEXT_TYPE = exports.TEXT_TYPE = {
  default: {
    type: 'default',
    size: 'normal',
    lineHeight: 'normal'
  },
  sub: {
    type: 'sub',
    size: 'small',
    lineHeight: 'large'
  },
  small: {
    type: 'small',
    size: 'XSmall',
    lineHeight: 'small'
  },
  titleNormal: {
    type: 'titleNormal',
    size: 'titleNormal',
    lineHeight: 'titleSmall'
  },
  medium: {
    type: 'medium',
    size: 'medium',
    lineHeight: 'small'
  },
  titleSmall: {
    type: 'titleSmall',
    size: 'titleSmall',
    lineHeight: 'titleSmall'
  },
  textSmall: {
    type: 'small',
    size: 'small',
    lineHeight: 'small'
  },
  semiSmall: {
    type: 'semiSmall',
    size: 'XSmall',
    lineHeight: 'semiSmall'
  }
};
const TEXT_ALIGN = exports.TEXT_ALIGN = ['left', 'center', 'right', 'justify'];
const DISPLAY = exports.DISPLAY = {
  block: 'block',
  inlineFlex: 'inline-flex',
  inline: 'inline'
};
const ARR_TEXT_TYPE = exports.ARR_TEXT_TYPE = Object.keys(TEXT_TYPE);
const DEFAULT_TAG = exports.DEFAULT_TAG = 'a';